var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.826 44.764 5.88 1.554v-2.043l.47-.469h3.366v4.066H24.94l-4.432-1.916-1.683-1.192Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.001 44.764-5.752 1.554v-2.043l-.49-.469h-3.345v4.066h3.6l4.432-1.916 1.555-1.192Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.175 40.336-.468 3.939.596-.469h6.221l.725.469-.49-3.939-.959-.596-4.794.107-.83.49Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21.937 13.62 2.876 6.706 1.321 19.52H30.8l1.449-19.52 2.642-6.706H21.937Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.366 28.351 6 38.06l8.395-.49h5.39v-4.172l-.235-8.622-1.214.958-8.97 2.618Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m15.716 29.437 9.822.234-1.087 5.024-4.666-1.192-4.07-4.066Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m15.716 29.565 4.069 3.832v3.831l-4.07-7.663Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m19.785 33.503 4.794 1.192 1.555 5.152-1.087.596-5.262-3.108v-3.832Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m19.785 37.335-.959 7.43 6.35-4.429-5.391-3.001Z",
    fill: "#EB8F35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m25.538 29.671.596 10.176-1.79-5.194 1.194-4.982Z",
    fill: "#EA8E3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m14.267 37.462 5.518-.127-.959 7.43-4.56-7.303Z",
    fill: "#D87C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m8.642 48 10.184-3.236-4.56-7.302L6 38.058 8.642 48Z",
    fill: "#EB8F35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m24.813 20.326-5.156 4.321-3.941 4.79 9.822.362-.725-9.473Z",
    fill: "#E8821E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m18.826 44.764 6.35-4.428-.47 3.832v2.15l-4.325-.83-1.555-.724ZM38.001 44.764l-6.242-4.428.49 3.832v2.15l4.304-.83L38 44.764Z",
    fill: "#DFCEC3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m22.896 31.821 1.32 2.768-4.666-1.192 3.346-1.576Z",
    fill: "#393939"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m8.514 8 16.3 12.326-2.75-6.706L8.515 8Z",
    fill: "#E88F35"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m8.514 8-2.152 6.578 1.193 7.195-.83.469 1.193 1.085-.96.83L8.28 25.35l-.831.723 1.917 2.385 8.991-2.746c4.39-3.513 6.541-5.301 6.477-5.386-.064-.085-5.54-4.194-16.32-12.326Z",
    fill: "#8E5A30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m47.461 28.351 3.367 9.708-8.395-.49h-5.39v-4.172l.234-8.622 1.193.958 8.991 2.618Z",
    fill: "#F89D35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m41.112 29.437-9.822.234 1.065 5.024 4.688-1.192 4.07-4.066Z",
    fill: "#D87C30"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m41.112 29.565-4.07 3.832v3.831l4.07-7.663Z",
    fill: "#EA8D3A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m37.043 33.503-4.794 1.192-1.556 5.152 1.066.596 5.284-3.108v-3.832Z",
    fill: "#F89D35"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m37.043 37.335.958 7.43-6.242-4.322 5.284-3.108Z",
    fill: "#EB8F35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m31.29 29.671-.596 10.176 1.79-5.194-1.194-4.982Z",
    fill: "#EA8E3A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m42.56 37.462-5.517-.127.958 7.43 4.56-7.303Z",
    fill: "#D87C30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.186 48 38 44.764l4.56-7.302 8.267.596L48.186 48Z",
    fill: "#EB8F35"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m32.014 20.326 5.135 4.321 3.963 4.79-9.822.362.724-9.473Z",
    fill: "#E8821E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m33.932 31.821-1.321 2.768 4.666-1.192-3.345-1.576Z",
    fill: "#393939"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M48.313 8 32.014 20.326l2.749-6.706L48.313 8Z",
    fill: "#E88F35"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m48.313 8 2.152 6.578-1.193 7.195.831.469-1.193 1.085.959.83-1.321 1.193.83.723-1.917 2.385-8.99-2.746c-4.39-3.513-6.563-5.301-6.478-5.386.085-.085 5.518-4.194 16.32-12.326Z",
    fill: "#8E5A30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.08ead59a4f322013b71f056ff0b4ffa9.svg";
export { ForwardRef as ReactComponent };